module.exports = __webpack_public_path__ + "static/uni_jpb-59371dc64c14bd1cc79346314ce7a1ae.png";